import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import { GetDeviceApiKey, MakeBackup } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import ErrorToast from "../toasts/ErrorToast";

const ApiKeyModal = ({ device, update }) => {
  const { setApiKeyModal, authUser, setIsLoading } = useContext(Context);
  const [apiKey, setApiKey] = useState("");
  const [limited, setLimited] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setApiKeyModal(modalName);

    if (!modalName.current) return;

    const $modal = window.$(modalName.current);

    const handleShown = () => setIsModalOpen(true);
    const handleHidden = () => setIsModalOpen(false);

    $modal.on("shown.bs.modal", handleShown);
    $modal.on("hidden.bs.modal", handleHidden);

    return () => {
      $modal.off("shown.bs.modal", handleShown);
      $modal.off("hidden.bs.modal", handleHidden);
    };
  }, [setApiKeyModal]);

  useEffect(() => {
    setApiKey("");
    if (!isModalOpen) return; // فقط وقتی مدال باز است
    if (!device) return;

    setIsLoading(true);

    GetDeviceApiKey({ device_id: device.id })
      .then(({ data }) => setApiKey(data.api_code))
      .finally(() => setIsLoading(false));
  }, [isModalOpen, device, update, setIsLoading]);

  const handleCopy = async () => {
    if (!apiKey) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(apiKey);
      } else {
        const input = apiKey;
        input.removeAttribute("disabled");
        input.select();
        document.execCommand("copy");
        input.setAttribute("disabled", "disabled");
        window.getSelection().removeAllRanges();
      }

      SuccessToast("کلید API با موفقیت کپی شد");
    } catch (err) {
      ErrorToast("خطا در کپی کردن کلید API");
    }
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="backupModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              کلید دسترسی API
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <label htmlFor="defaultFormControlInput" className="form-label">
                کلید
              </label>
              <input
                type="text"
                className="form-control"
                value={apiKey}
                disabled="disabled"
              />
              <div id="defaultFormControlHelp" className="form-text">
                این کلید را در اختیار کسی قرار ندهید
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleCopy}
            >
              کپی
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyModal;
